import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { api, apiError } from '../lib/api';

const HERO_IMG = 'https://businessprideindia.com/bu_images/the-business-pride-india.jpeg';

// Animated gradient background for tabs/badges
const animatedGradientStyle = `
  @keyframes gradientShift {
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
  }
  @keyframes pulseGlow {
    0% { box-shadow: 0 0 0 0 rgba(67, 56, 202, 0.4); }
    70% { box-shadow: 0 0 0 12px rgba(67, 56, 202, 0); }
    100% { box-shadow: 0 0 0 0 rgba(67, 56, 202, 0); }
  }
  @keyframes floatBlob {
    0%, 100% { transform: translate(0, 0) scale(1); }
    33% { transform: translate(30px, -30px) scale(1.1); }
    66% { transform: translate(-20px, 20px) scale(0.95); }
  }
  @keyframes floatBlob2 {
    0%, 100% { transform: translate(0, 0) scale(1); }
    33% { transform: translate(-40px, 30px) scale(1.15); }
    66% { transform: translate(25px, -25px) scale(0.9); }
  }
  @keyframes shimmerSweep {
    0% { transform: translateX(-120%) skewX(-20deg); }
    100% { transform: translateX(220%) skewX(-20deg); }
  }
  @keyframes gridMove {
    0% { background-position: 0 0; }
    100% { background-position: 60px 60px; }
  }
  @keyframes sectionBorderGlow {
    0%, 100% { border-color: rgba(199, 210, 254, 0.6); box-shadow: 0 0 40px -10px rgba(99, 102, 241, 0.1); }
    50% { border-color: rgba(167, 139, 250, 0.8); box-shadow: 0 0 60px -10px rgba(99, 102, 241, 0.25); }
  }
  @keyframes ringPulse {
    0% { transform: scale(0.9); opacity: 0.7; }
    70% { transform: scale(1.6); opacity: 0; }
    100% { transform: scale(1.6); opacity: 0; }
  }
  @keyframes slideInRight {
    from { transform: translateX(60px); opacity: 0; }
    to { transform: translateX(0); opacity: 1; }
  }
  @keyframes slideInLeft {
    from { transform: translateX(-60px); opacity: 0; }
    to { transform: translateX(0); opacity: 1; }
  }
  @keyframes fadeUpBanner {
    from { transform: translateY(20px); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
  }
  @keyframes progressBar {
    from { width: 0%; }
    to { width: 100%; }
  }
  @keyframes bannerImgZoom {
    from { transform: scale(1); }
    to { transform: scale(1.08); }
  }
  @keyframes bannerGlowPulse {
    0%, 100% { box-shadow: 0 20px 50px -20px rgba(67, 56, 202, 0.25); }
    50% { box-shadow: 0 25px 60px -18px rgba(99, 102, 241, 0.45); }
  }
  @keyframes shimmerText {
    0% { background-position: -200% center; }
    100% { background-position: 200% center; }
  }
  @keyframes searchGlow {
    0%, 100% { box-shadow: 0 0 0 0 rgba(67, 56, 202, 0.15), 0 10px 30px -10px rgba(67, 56, 202, 0.2); }
    50% { box-shadow: 0 0 0 4px rgba(67, 56, 202, 0.08), 0 14px 40px -10px rgba(67, 56, 202, 0.35); }
  }
  @keyframes searchBorderShift {
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
  }

  .animated-tab {
    background: linear-gradient(120deg, #EEF2FF, #E0E7FF, #C7D2FE, #EEF2FF);
    background-size: 300% 300%;
    animation: gradientShift 4s ease infinite;
    transition: all 0.3s ease;
  }
  .animated-tab:hover {
    animation: gradientShift 2s ease infinite, pulseGlow 1.5s ease infinite;
    transform: translateY(-1px);
  }
  .animated-tab-solid {
    background: linear-gradient(120deg, #4338CA, #6366F1, #818CF8, #4338CA);
    background-size: 300% 300%;
    animation: gradientShift 4s ease infinite;
    color: white !important;
    border: none !important;
  }
  .animated-tab-solid:hover {
    animation: gradientShift 2s ease infinite, pulseGlow 1.5s ease infinite;
    transform: translateY(-1px);
    box-shadow: 0 8px 25px rgba(67, 56, 202, 0.35);
  }
  .animated-tab-outline {
    background: linear-gradient(120deg, #ffffff, #F5F3FF, #EDE9FE, #ffffff);
    background-size: 300% 300%;
    animation: gradientShift 4s ease infinite;
    border: 1px solid #C7D2FE !important;
    color: #4338CA !important;
    transition: all 0.3s ease;
  }
  .animated-tab-outline:hover {
    animation: gradientShift 2s ease infinite, pulseGlow 1.5s ease infinite;
    transform: translateY(-1px);
    border-color: #4338CA !important;
    box-shadow: 0 6px 20px rgba(67, 56, 202, 0.15);
  }
  .animated-chip {
    background: linear-gradient(120deg, #f7fafc, #EEF2FF, #E0E7FF, #f7fafc);
    background-size: 300% 300%;
    animation: gradientShift 5s ease infinite;
    transition: all 0.25s ease;
  }
  .animated-chip:hover {
    animation: gradientShift 2.5s ease infinite, pulseGlow 1.5s ease infinite;
    transform: translateY(-2px) scale(1.03);
    background: linear-gradient(120deg, #4338CA, #6366F1, #818CF8, #4338CA) !important;
    color: white !important;
    border-color: #4338CA !important;
    box-shadow: 0 6px 20px rgba(67, 56, 202, 0.3);
  }
  .animated-dropdown-trigger {
    background: linear-gradient(120deg, #ffffff, #F5F3FF, #EEF2FF, #ffffff);
    background-size: 300% 300%;
    animation: gradientShift 6s ease infinite;
    transition: all 0.3s ease;
  }
  .animated-dropdown-trigger:hover {
    animation: gradientShift 3s ease infinite;
    border-color: #4338CA !important;
    box-shadow: 0 4px 20px rgba(67, 56, 202, 0.15) !important;
  }
  .animated-badge {
    background: linear-gradient(120deg, #EEF2FF, #E0E7FF, #C7D2FE, #EEF2FF);
    background-size: 300% 300%;
    animation: gradientShift 5s ease infinite;
  }
  .animated-search-btn {
    background: linear-gradient(120deg, #4338CA, #6366F1, #818CF8, #4338CA);
    background-size: 300% 300%;
    animation: gradientShift 4s ease infinite;
    transition: all 0.3s ease;
    color: white;
  }
  .animated-search-btn:hover {
    animation: gradientShift 2s ease infinite, pulseGlow 1.5s ease infinite;
    transform: translateY(-2px);
    box-shadow: 0 10px 30px rgba(67, 56, 202, 0.4);
  }
  .animated-link-btn {
    background: linear-gradient(120deg, #ffffff, #F5F3FF, #EDE9FE, #ffffff);
    background-size: 300% 300%;
    animation: gradientShift 5s ease infinite;
    border: 1px solid #C7D2FE;
    transition: all 0.3s ease;
  }
  .animated-link-btn:hover {
    animation: gradientShift 2.5s ease infinite, pulseGlow 1.5s ease infinite;
    border-color: #4338CA;
    transform: translateY(-1px);
    box-shadow: 0 6px 20px rgba(67, 56, 202, 0.15);
  }
  .animated-city-item:hover {
    background: linear-gradient(90deg, #EEF2FF, #F5F3FF, #EEF2FF) !important;
  }

  /* ===== Beautiful Search Input Wrapper ===== */
  .search-input-wrap {
    position: relative;
    width: 100%;
    z-index: 10000;
    border-radius: 12px;
    padding: 2px;
    background: linear-gradient(120deg, #C7D2FE, #A78BFA, #818CF8, #C7D2FE);
    background-size: 300% 300%;
    animation: searchBorderShift 6s ease infinite, searchGlow 3s ease-in-out infinite;
    transition: transform 0.25s ease;
  }
  .search-input-wrap:focus-within {
    transform: translateY(-1px);
    animation: searchBorderShift 3s ease infinite, searchGlow 1.8s ease-in-out infinite;
  }
  .search-input-inner {
    position: relative;
    border-radius: 10px;
    background: #ffffff;
    overflow: hidden;
    display: flex;
    align-items: center;
  }
  .search-input-icon {
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: #818CF8;
    pointer-events: none;
    transition: color 0.25s ease;
  }
  .search-input-wrap:focus-within .search-input-icon {
    color: #4338CA;
  }
  .search-input-field {
    width: 100%;
    border: none !important;
    outline: none !important;
    background: transparent !important;
    padding: 0.78rem 1rem 0.78rem 2.7rem !important;
    font-size: 0.98rem;
    color: #1a202c;
    box-shadow: none !important;
  }
  .search-input-field::placeholder {
    color: #a0aec0;
    font-weight: 400;
  }
  .search-input-inner::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg, transparent, rgba(238, 242, 255, 0.6), transparent);
    transform: translateX(-120%) skewX(-20deg);
    pointer-events: none;
  }
  .search-input-wrap:focus-within .search-input-inner::before {
    animation: shimmerSweep 1.8s ease-in-out infinite;
  }
  .search-clear-btn {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    width: 22px;
    height: 22px;
    border-radius: 50%;
    border: none;
    background: #EEF2FF;
    color: #6366F1;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
  }
  .search-clear-btn:hover {
    background: #4338CA;
    color: #fff;
    transform: translateY(-50%) scale(1.08);
  }

  /* Stacked search layout */
  .search-stack {
    display: flex;
    flex-direction: column;
    gap: 0.7rem;
    position: relative;
    overflow: visible;
  }
  .search-stack-bottom {
    display: flex;
    gap: 0.7rem;
    align-items: center;
    flex-wrap: wrap;
  }
  .search-stack-bottom .city-select {
    flex: 1 1 200px;
    min-width: 170px;
  }
  .search-stack-bottom .cat-select {
    flex: 1 1 200px;
    min-width: 170px;
    max-width: none;
  }
  .search-stack-bottom .search-submit {
    flex: 0 0 auto;
  }

  /* ===== Sponsored Banner Carousel ===== */
  .sponsored-banner-wrap {
    position: relative;
    border-radius: 24px;
    overflow: hidden;
    animation: bannerGlowPulse 5s ease-in-out infinite;
    background: linear-gradient(135deg, #EEF2FF 0%, #F5F3FF 50%, #EDE9FE 100%);
    border: 1px solid rgba(199, 210, 254, 0.7);
  }
  .sponsored-banner-track {
    display: flex;
    transition: transform 0.85s cubic-bezier(0.65, 0, 0.35, 1);
    will-change: transform;
  }
  .sponsored-banner-slide {
    flex: 0 0 100%;
    min-width: 100%;
    position: relative;
    overflow: hidden;
  }
  .sponsored-banner-card {
    display: flex;
    align-items: stretch;
    min-height: 200px;
    position: relative;
    background: #fff;
    text-decoration: none;
    color: inherit;
    overflow: hidden;
  }
  .sponsored-banner-img-wrap {
    flex: 0 0 42%;
    position: relative;
    overflow: hidden;
    background: linear-gradient(135deg, #EEF2FF, #E0E7FF);
  }
  .sponsored-banner-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    animation: bannerImgZoom 8s ease-in-out infinite alternate;
  }
  .sponsored-banner-img-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg, transparent 60%, rgba(255,255,255,0.15) 100%);
  }
  .sponsored-banner-body {
    flex: 1;
    padding: 1.75rem 2rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 0.5rem;
    position: relative;
    z-index: 2;
    animation: fadeUpBanner 0.7s ease both;
  }
  .sponsored-banner-eyebrow {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    font-size: 0.68rem;
    font-weight: 800;
    letter-spacing: 0.15em;
    text-transform: uppercase;
    color: #F59E0B;
    background: linear-gradient(120deg, #FEF3C7, #FDE68A, #FEF3C7);
    background-size: 200% 100%;
    animation: shimmerText 4s linear infinite;
    padding: 0.3rem 0.7rem;
    border-radius: 20px;
    align-self: flex-start;
  }
  .sponsored-banner-title {
    font-size: 1.5rem;
    font-weight: 800;
    color: #1a202c;
    line-height: 1.2;
    letter-spacing: -0.01em;
  }
  .sponsored-banner-cta {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    font-size: 0.85rem;
    font-weight: 600;
    color: #4338CA;
    margin-top: 0.35rem;
    transition: gap 0.3s ease;
  }
  .sponsored-banner-card:hover .sponsored-banner-cta { gap: 0.7rem; }
  .sponsored-banner-card:hover .sponsored-banner-title { color: #4338CA; }

  /* Progress bar under banner */
  .sponsored-progress {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 4px;
    background: linear-gradient(90deg, #4338CA, #6366F1, #818CF8, #A78BFA);
    background-size: 200% 100%;
    animation: gradientShift 3s linear infinite, progressBar 5s linear forwards;
    border-radius: 0 4px 4px 0;
    z-index: 5;
  }

  /* Nav arrows */
  .banner-nav-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: none;
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(8px);
    color: #4338CA;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 10;
    box-shadow: 0 4px 16px rgba(15, 23, 42, 0.15);
    transition: all 0.25s ease;
    opacity: 0;
  }
  .sponsored-banner-wrap:hover .banner-nav-btn { opacity: 1; }
  .banner-nav-btn:hover {
    background: #4338CA;
    color: #fff;
    transform: translateY(-50%) scale(1.1);
    box-shadow: 0 6px 22px rgba(67, 56, 202, 0.4);
  }
  .banner-nav-prev { left: 14px; }
  .banner-nav-next { right: 14px; }

  /* Dots */
  .banner-dots {
    position: absolute;
    bottom: 14px;
    right: 18px;
    display: flex;
    gap: 7px;
    z-index: 10;
  }
  .banner-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    border: none;
    padding: 0;
    background: rgba(67, 56, 202, 0.25);
    cursor: pointer;
    transition: all 0.3s ease;
  }
  .banner-dot.active {
    width: 24px;
    border-radius: 4px;
    background: linear-gradient(90deg, #4338CA, #818CF8);
  }
  .banner-dot:hover { background: rgba(67, 56, 202, 0.55); }

  /* ===== Animated Highlighted Section Background ===== */
  .highlight-section {
    position: relative;
    border-radius: 32px;
    padding: 3rem 2.5rem;
    margin: 4rem auto;
    max-width: 1240px;
    background:
      linear-gradient(135deg, rgba(238, 242, 255, 0.9) 0%, rgba(245, 243, 255, 0.95) 40%, rgba(237, 233, 254, 0.9) 100%);
    border: 1px solid rgba(199, 210, 254, 0.6);
    overflow: hidden;
    isolation: isolate;
    animation: sectionBorderGlow 6s ease-in-out infinite;
  }
  .highlight-section::before {
    content: '';
    position: absolute;
    inset: 0;
    background-image:
      linear-gradient(rgba(99, 102, 241, 0.06) 1px, transparent 1px),
      linear-gradient(90deg, rgba(99, 102, 241, 0.06) 1px, transparent 1px);
    background-size: 60px 60px;
    animation: gridMove 20s linear infinite;
    z-index: -2;
    -webkit-mask-image: radial-gradient(ellipse at center, black 30%, transparent 80%);
    mask-image: radial-gradient(ellipse at center, black 30%, transparent 80%);
  }
  .highlight-section .blob {
    position: absolute;
    border-radius: 50%;
    filter: blur(60px);
    z-index: -1;
    pointer-events: none;
  }
  .highlight-section .blob-1 {
    width: 320px; height: 320px;
    top: -120px; left: -80px;
    background: radial-gradient(circle, rgba(99, 102, 241, 0.35), transparent 70%);
    animation: floatBlob 14s ease-in-out infinite;
  }
  .highlight-section .blob-2 {
    width: 380px; height: 380px;
    bottom: -150px; right: -100px;
    background: radial-gradient(circle, rgba(167, 139, 250, 0.3), transparent 70%);
    animation: floatBlob2 18s ease-in-out infinite;
  }
  .highlight-section .blob-3 {
    width: 220px; height: 220px;
    top: 40%; right: 30%;
    background: radial-gradient(circle, rgba(129, 140, 248, 0.22), transparent 70%);
    animation: floatBlob 22s ease-in-out infinite reverse;
  }
  .highlight-section::after {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 4px;
    background: linear-gradient(90deg, transparent, #4338CA, #818CF8, #A78BFA, #818CF8, #4338CA, transparent);
    background-size: 200% 100%;
    animation: gradientShift 5s ease infinite;
    z-index: 2;
  }

  .highlight-section-alt {
    background:
      linear-gradient(135deg, rgba(245, 243, 255, 0.95) 0%, rgba(237, 233, 254, 0.9) 50%, rgba(238, 242, 255, 0.95) 100%);
  }
  .highlight-section-alt::before {
    background-image:
      radial-gradient(circle at 20% 30%, rgba(99, 102, 241, 0.08) 0px, transparent 2px),
      radial-gradient(circle at 80% 70%, rgba(167, 139, 250, 0.08) 0px, transparent 2px);
    background-size: 40px 40px;
    animation: none;
  }

  .highlight-section .shimmer-overlay {
    position: absolute;
    inset: 0;
    overflow: hidden;
    pointer-events: none;
    z-index: 0;
    border-radius: 32px;
  }
  .highlight-section .shimmer-overlay::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 40%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.5), transparent);
    animation: shimmerSweep 8s ease-in-out infinite;
    animation-delay: 2s;
  }

  .deco-ring {
    position: absolute;
    border-radius: 50%;
    border: 2px solid rgba(99, 102, 241, 0.25);
    pointer-events: none;
    z-index: -1;
  }
  .deco-ring-1 { width: 80px; height: 80px; top: 40px; right: 60px; animation: ringPulse 4s ease-out infinite; }
  .deco-ring-2 { width: 120px; height: 120px; bottom: 50px; left: 40px; animation: ringPulse 5s ease-out infinite; animation-delay: 1s; border-color: rgba(167, 139, 250, 0.3); }

  /* ===== Enhanced Category Card ===== */
  .category-card {
    position: relative;
    background: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border: 1px solid rgba(255, 255, 255, 0.9);
    border-radius: 18px;
    padding: 1.4rem 1.1rem;
    height: 100%;
    overflow: hidden;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
    box-shadow: 0 2px 8px rgba(67, 56, 202, 0.04);
  }
  .category-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #4338CA, #6366F1, #818CF8, #A78BFA);
    background-size: 300% 300%;
    animation: gradientShift 4s ease infinite;
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  .category-card::after {
    content: '';
    position: absolute;
    right: -40px;
    bottom: -40px;
    width: 120px;
    height: 120px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(99,102,241,0.08), transparent 70%);
    transition: all 0.4s ease;
  }
  .category-card:hover {
    transform: translateY(-6px);
    border-color: #C7D2FE;
    background: #ffffff;
    box-shadow: 0 18px 40px -18px rgba(67, 56, 202, 0.3);
  }
  .category-card:hover::before { opacity: 1; }
  .category-card:hover::after {
    transform: scale(1.6);
    background: radial-gradient(circle, rgba(99,102,241,0.14), transparent 70%);
  }
  .category-icon-wrap {
    width: 52px;
    height: 52px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.4rem;
    font-weight: 800;
    color: #4338CA;
    background: linear-gradient(135deg, #EEF2FF, #E0E7FF);
    margin-bottom: 0.5rem;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    z-index: 1;
  }
  .category-card:hover .category-icon-wrap {
    background: linear-gradient(135deg, #4338CA, #6366F1);
    color: #fff;
    transform: rotate(-6deg) scale(1.05);
    box-shadow: 0 8px 20px -6px rgba(67, 56, 202, 0.5);
  }
  .category-name {
    font-weight: 700;
    color: #1a202c;
    font-size: 1rem;
    position: relative;
    z-index: 1;
  }
  .category-count {
    font-size: 0.8rem;
    color: #94a3b8;
    position: relative;
    z-index: 1;
    transition: color 0.3s ease;
  }
  .category-card:hover .category-count { color: #6366F1; }
  .category-arrow {
    position: absolute;
    top: 1.1rem;
    right: 1.1rem;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #F5F3FF;
    opacity: 0;
    transform: translateX(-6px);
    transition: all 0.35s ease;
    z-index: 1;
  }
  .category-card:hover .category-arrow {
    opacity: 1;
    transform: translateX(0);
  }

  /* ===== Enhanced Featured Business Card ===== */
  .featured-card {
    position: relative;
    display: flex;
    gap: 1rem;
    background: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border: 1px solid rgba(255, 255, 255, 0.9);
    border-radius: 18px;
    padding: 1rem;
    height: 100%;
    overflow: hidden;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    align-items: stretch;
    box-shadow: 0 2px 8px rgba(67, 56, 202, 0.04);
  }
  .featured-card::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 18px;
    padding: 1px;
    background: linear-gradient(130deg, transparent 40%, #C7D2FE 70%, #A78BFA 100%);
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    opacity: 0;
    transition: opacity 0.4s ease;
    pointer-events: none;
  }
  .featured-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 24px 48px -20px rgba(67, 56, 202, 0.35);
    border-color: transparent;
    background: #ffffff;
  }
  .featured-card:hover::before { opacity: 1; }
  .featured-thumb {
    flex: 0 0 92px;
    width: 92px;
    height: 92px;
    border-radius: 14px;
    background-size: cover;
    background-position: center;
    background-color: #EEF2FF;
    position: relative;
    overflow: hidden;
    transition: transform 0.4s ease;
    align-self: center;
  }
  .featured-card:hover .featured-thumb { transform: scale(1.04); }
  .featured-thumb-placeholder {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.8rem;
    font-weight: 800;
    color: #818CF8;
    background: linear-gradient(135deg, #EEF2FF, #E0E7FF);
  }
  .featured-body {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 0.2rem;
  }
  .featured-name {
    font-weight: 700;
    font-size: 1.05rem;
    color: #1a202c;
    line-height: 1.25;
    transition: color 0.25s ease;
  }
  .featured-card:hover .featured-name { color: #4338CA; }
  .featured-meta {
    font-size: 0.8rem;
    color: #64748b;
    display: flex;
    align-items: center;
    gap: 0.4rem;
    flex-wrap: wrap;
  }
  .featured-meta .dot {
    width: 3px;
    height: 3px;
    border-radius: 50%;
    background: #cbd5e1;
    display: inline-block;
  }
  .featured-tagline {
    font-size: 0.85rem;
    color: #94a3b8;
    margin-top: 0.15rem;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .featured-premium-badge {
    position: absolute;
    top: 0.7rem;
    right: 0.7rem;
    font-size: 0.65rem;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: #fff;
    padding: 0.25rem 0.6rem;
    border-radius: 20px;
    background: linear-gradient(120deg, #F59E0B, #F97316, #FBBF24, #F59E0B);
    background-size: 300% 300%;
    animation: gradientShift 4s ease infinite;
    box-shadow: 0 4px 12px rgba(245, 158, 11, 0.35);
    z-index: 2;
  }
  .featured-wa {
    margin-top: 0.35rem;
    display: inline-flex;
    align-items: center;
    gap: 0.3rem;
    font-size: 0.72rem;
    font-weight: 600;
    color: #16a34a;
    opacity: 0;
    transform: translateY(4px);
    transition: all 0.3s ease;
  }
  .featured-card:hover .featured-wa {
    opacity: 1;
    transform: translateY(0);
  }

  .section-eyebrow {
    font-size: 0.72rem;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    font-weight: 800;
    background: linear-gradient(90deg, #4338CA, #7C3AED);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    display: inline-block;
  }
  .section-title {
    font-weight: 800;
    letter-spacing: -0.02em;
  }

  @media (max-width: 768px) {
    .highlight-section {
      padding: 2rem 1.25rem;
      border-radius: 24px;
      margin: 2.5rem auto;
    }
    .deco-ring { display: none; }
    .sponsored-banner-card { flex-direction: column; min-height: unset; }
    .sponsored-banner-img-wrap { flex: 0 0 160px; width: 100%; }
    .sponsored-banner-body { padding: 1.25rem; }
    .sponsored-banner-title { font-size: 1.15rem; }
    .banner-nav-btn { opacity: 1; width: 32px; height: 32px; }
    .banner-nav-prev { left: 8px; }
    .banner-nav-next { right: 8px; }
    .search-stack-bottom { flex-direction: column; align-items: stretch; }
    .search-stack-bottom .city-select,
    .search-stack-bottom .cat-select { flex: 1 1 auto; min-width: 0; width: 100%; }
    .search-stack-bottom .search-submit { width: 100%; }
  }
`;

export default function Home() {
  const [categories, setCategories] = useState([]);
  const [cities, setCities] = useState([]);
  const [featured, setFeatured] = useState([]);
  const [ads, setAds] = useState([]);
  const [q, setQ] = useState('');
  const [city, setCity] = useState('');
  const [category, setCategory] = useState('');

  // Main search city dropdown
  const [showCityDropdown, setShowCityDropdown] = useState(false);
  const [citySearchTerm, setCitySearchTerm] = useState('');
  const cityDropdownRef = useRef(null);

  // Explore cities dropdown
  const [showExploreCityDropdown, setShowExploreCityDropdown] = useState(false);
  const [exploreCitySearchTerm, setExploreCitySearchTerm] = useState('');
  const exploreDropdownRef = useRef(null);

  // Business name search suggestions
  const [businessSuggestions, setBusinessSuggestions] = useState([]);
  const [showBusinessDropdown, setShowBusinessDropdown] = useState(false);
  const [businessSearchTerm, setBusinessSearchTerm] = useState('');
  const [loadingSuggestions, setLoadingSuggestions] = useState(false);
  const businessDropdownRef = useRef(null);
  const debounceRef = useRef(null);

  // Sponsored banner carousel
  const [activeSlide, setActiveSlide] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const autoplayRef = useRef(null);
  const SLIDE_DURATION = 5000;

  const nav = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const [c, ci, feats, adsRes] = await Promise.all([
          api.get('/categories'),
          api.get('/cities'),
          api.get('/businesses?premium=1'),
          api.get('/ads?placement=home_banner'),
        ]);
        setCategories(c.data.categories || []);
        setCities(ci.data.cities || []);
        setFeatured((feats.data.businesses || []).slice(0, 6));
        setAds(adsRes.data.ads || []);
      } catch (e) { console.error(apiError(e)); }
    })();
  }, []);

  // Debounced fetch for business name suggestions
  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);

    const term = businessSearchTerm.trim();
    if (term.length < 2) {
      setBusinessSuggestions([]);
      setLoadingSuggestions(false);
      return;
    }

    setLoadingSuggestions(true);
    debounceRef.current = setTimeout(async () => {
      try {
        const res = await api.get('/businesses', {
          params: { q: term, limit: 8 }
        });
        setBusinessSuggestions(res.data.businesses || []);
      } catch (e) {
        console.error(apiError(e));
        setBusinessSuggestions([]);
      } finally {
        setLoadingSuggestions(false);
      }
    }, 300);

    return () => clearTimeout(debounceRef.current);
  }, [businessSearchTerm]);

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (cityDropdownRef.current && !cityDropdownRef.current.contains(event.target)) {
        setShowCityDropdown(false);
      }
      if (exploreDropdownRef.current && !exploreDropdownRef.current.contains(event.target)) {
        setShowExploreCityDropdown(false);
      }
      if (businessDropdownRef.current && !businessDropdownRef.current.contains(event.target)) {
        setShowBusinessDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Sponsored banner autoplay
  const bannerSlides = ads.slice(0, 5);
  const slideCount = bannerSlides.length;

  useEffect(() => {
    if (slideCount <= 1 || isPaused) return;
    autoplayRef.current = setInterval(() => {
      setActiveSlide(prev => (prev + 1) % slideCount);
    }, SLIDE_DURATION);
    return () => clearInterval(autoplayRef.current);
  }, [slideCount, isPaused, activeSlide]);

  const goToSlide = (idx) => {
    setActiveSlide(idx);
  };
  const nextSlide = () => {
    if (slideCount === 0) return;
    setActiveSlide(prev => (prev + 1) % slideCount);
  };
  const prevSlide = () => {
    if (slideCount === 0) return;
    setActiveSlide(prev => (prev - 1 + slideCount) % slideCount);
  };

  const doSearch = (e) => {
    e.preventDefault();
    setShowBusinessDropdown(false);
    const params = new URLSearchParams();
    if (q) params.set('q', q);
    if (city) params.set('city', city);
    if (category) params.set('category', category);
    nav('/search?' + params.toString());
    setShowCityDropdown(false);
  };

  const filteredCities = cities.filter(c =>
    c.name.toLowerCase().includes(citySearchTerm.toLowerCase())
  );

  const filteredExploreCities = cities.filter(c =>
    c.name.toLowerCase().includes(exploreCitySearchTerm.toLowerCase())
  );

  const selectCity = (citySlug) => {
    setCity(citySlug);
    setShowCityDropdown(false);
    setCitySearchTerm('');
  };

  const selectExploreCity = (citySlug) => {
    setShowExploreCityDropdown(false);
    setExploreCitySearchTerm('');
    nav(`/search?city=${citySlug}`);
  };

  const selectBusiness = (biz) => {
    setShowBusinessDropdown(false);
    setBusinessSearchTerm('');
    nav(`/business/${biz.slug}`);
  };

  const goToFullSearch = (term) => {
    setShowBusinessDropdown(false);
    const params = new URLSearchParams();
    if (term) params.set('q', term);
    if (city) params.set('city', city);
    if (category) params.set('category', category);
    nav('/search?' + params.toString());
  };

  return (
    <div data-testid="home-page">
      <style>{animatedGradientStyle}</style>

      <section className="ap-hero ap-grain" style={{ overflow: 'visible' }}>
        <div className="container content" style={{ overflow: 'visible' }}>
          <div className="row align-items-center g-5">
            <div className="col-lg-7">
              <span
                className="badge rounded-pill animated-badge"
                style={{
                  color:'#4338CA',
                  letterSpacing:'.15em',
                  fontWeight:700,
                  padding:'.55rem .85rem',
                  display: 'inline-block'
                }}
              >
                LOCAL · TRUSTED · VERIFIED
              </span>
              <h1 className="mt-3">Find the businesses that <em style={{fontStyle:'normal', color:'var(--ap-primary)'}}>power your day</em>.</h1>
              <p className="lead mt-3">Search restaurants, gyms, salons, services and more — across cities. Talk to owners directly on WhatsApp or call in one tap.</p>

              <form className="ap-search mt-4" onSubmit={doSearch} data-testid="home-search-form">
                <div className="search-stack">
                  {/* TOP: Business name search with suggestions */}
                  <div ref={businessDropdownRef} className="search-input-wrap">
                    <div className="search-input-inner">
                      <span className="search-input-icon">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                          <circle cx="8" cy="8" r="5.5" stroke="currentColor" strokeWidth="1.8"/>
                          <path d="M12.5 12.5L16 16" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
                        </svg>
                      </span>
                      <input
                        className="form-control search-input-field"
                        placeholder="Search business name, e.g. Pizza Hut"
                        value={businessSearchTerm}
                        onChange={(e) => {
                          setBusinessSearchTerm(e.target.value);
                          setQ(e.target.value);
                          setShowBusinessDropdown(true);
                        }}
                        onFocus={() => {
                          if (businessSearchTerm.trim().length >= 2) setShowBusinessDropdown(true);
                        }}
                        data-testid="home-search-input"
                      />
                      {businessSearchTerm && (
                        <button
                          type="button"
                          className="search-clear-btn"
                          onClick={() => {
                            setBusinessSearchTerm('');
                            setQ('');
                            setBusinessSuggestions([]);
                            setShowBusinessDropdown(false);
                          }}
                          aria-label="Clear search"
                        >
                          <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                            <path d="M2 2L8 8M8 2L2 8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
                          </svg>
                        </button>
                      )}
                    </div>

                    {showBusinessDropdown && businessSearchTerm.trim().length >= 2 && (
                      <div
                        style={{
                          position: 'absolute',
                          top: 'calc(100% + 6px)',
                          left: 0,
                          right: 0,
                          background: 'white',
                          border: '1px solid #e2e8f0',
                          borderRadius: 12,
                          boxShadow: '0 24px 60px -12px rgba(67, 56, 202, 0.25)',
                          zIndex: 99999,
                          maxHeight: 340,
                          overflowY: 'auto',
                          padding: '0.35rem'
                        }}
                      >
                        {loadingSuggestions && (
                          <div style={{ padding: '0.75rem 1rem', color: '#a0aec0', fontSize: '0.9rem' }}>
                            Searching…
                          </div>
                        )}

                        {!loadingSuggestions && businessSuggestions.length === 0 && (
                          <div style={{ padding: '0.75rem 1rem', color: '#a0aec0', fontSize: '0.9rem' }}>
                            No businesses found for "{businessSearchTerm}"
                          </div>
                        )}

                        {businessSuggestions.map((b) => (
                          <div
                            key={b.id}
                            className="animated-city-item"
                            onClick={() => selectBusiness(b)}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '0.65rem',
                              padding: '0.55rem 0.75rem',
                              cursor: 'pointer',
                              borderRadius: 8
                            }}
                          >
                            <div
                              style={{
                                width: 36,
                                height: 36,
                                borderRadius: 8,
                                background: '#EEF2FF',
                                backgroundImage: (b.logo_url || b.cover_url) ? `url(${b.logo_url || b.cover_url})` : 'none',
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: '#818CF8',
                                fontWeight: 800,
                                flexShrink: 0
                              }}
                            >
                              {!(b.logo_url || b.cover_url) && b.name.substring(0, 1).toUpperCase()}
                            </div>
                            <div style={{ minWidth: 0, flex: 1 }}>
                              <div style={{ fontWeight: 600, color: '#1a202c', fontSize: '0.92rem' }}>
                                {b.name}
                              </div>
                              <div style={{ fontSize: '0.78rem', color: '#94a3b8' }}>
                                {b.category_name}
                                {b.city_name ? ` · ${b.city_name}` : ''}
                              </div>
                            </div>
                          </div>
                        ))}

                        {!loadingSuggestions && businessSuggestions.length > 0 && (
                          <div
                            onClick={() => goToFullSearch(businessSearchTerm)}
                            style={{
                              marginTop: '0.35rem',
                              padding: '0.6rem 0.9rem',
                              borderTop: '1px solid #eef2ff',
                              cursor: 'pointer',
                              color: '#4338CA',
                              fontWeight: 600,
                              fontSize: '0.88rem',
                              borderRadius: 8,
                              background: '#fafbff'
                            }}
                          >
                            See all results for "{businessSearchTerm}" →
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  {/* BOTTOM: City + Category + Search button */}
                  <div className="search-stack-bottom">
                    {/* City dropdown */}
                    <div
                      ref={cityDropdownRef}
                      className="city-select"
                      style={{ position: 'relative', zIndex: 9999 }}
                    >
                      <div
                        className="animated-dropdown-trigger"
                        onClick={() => setShowCityDropdown(!showCityDropdown)}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          padding: '0.55rem 1rem',
                          border: '1px solid #e2e8f0',
                          borderRadius: '10px',
                          cursor: 'pointer',
                          height: '46px',
                          background: '#fff'
                        }}
                      >
                        <span style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: city ? '#1a202c' : '#a0aec0' }}>
                          <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
                            <path d="M10 10C11.3807 10 12.5 8.88071 12.5 7.5C12.5 6.11929 11.3807 5 10 5C8.61929 5 7.5 6.11929 7.5 7.5C7.5 8.88071 8.61929 10 10 10Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M10 17.5C14.1667 13.3333 16.6667 9.52381 16.6667 7.5C16.6667 3.85786 13.6421 0.833333 10 0.833333C6.35786 0.833333 3.33333 3.85786 3.33333 7.5C3.33333 9.52381 5.83333 13.3333 10 17.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                          {city ? cities.find(c => c.slug === city)?.name || 'Any city' : 'Any city'}
                        </span>
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                          <path d="M2 4L6 8L10 4" stroke="#a0aec0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>

                      {showCityDropdown && (
                        <div style={{
                          position: 'absolute',
                          top: 'calc(100% + 6px)',
                          left: 0,
                          right: 0,
                          background: 'white',
                          border: '1px solid #e2e8f0',
                          borderRadius: '10px',
                          boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
                          zIndex: 99999,
                          maxHeight: 300,
                          display: 'flex',
                          flexDirection: 'column',
                          overflow: 'hidden'
                        }}>
                          <div style={{ padding: '0.5rem' }}>
                            <input
                              type="text"
                              placeholder="Search cities..."
                              value={citySearchTerm}
                              onChange={(e) => setCitySearchTerm(e.target.value)}
                              autoFocus
                              style={{
                                width: '100%',
                                padding: '0.5rem 0.75rem',
                                border: '1px solid #e2e8f0',
                                borderRadius: '6px',
                                fontSize: '0.9rem',
                                outline: 'none'
                              }}
                            />
                          </div>

                          <div style={{
                            overflowY: 'auto',
                            flex: 1,
                            padding: '0.25rem 0'
                          }}>
                            <div
                              className="animated-city-item"
                              onClick={() => selectCity('')}
                              style={{
                                padding: '0.5rem 1rem',
                                cursor: 'pointer',
                                background: city === '' ? '#f0f4ff' : 'transparent',
                                fontWeight: city === '' ? 600 : 400,
                                color: city === '' ? '#4338CA' : '#4a5568',
                                transition: 'background 0.2s'
                              }}
                            >
                              Any city
                            </div>
                            {filteredCities.map(c => (
                              <div
                                key={c.id}
                                className="animated-city-item"
                                onClick={() => selectCity(c.slug)}
                                style={{
                                  padding: '0.5rem 1rem',
                                  cursor: 'pointer',
                                  background: city === c.slug ? '#f0f4ff' : 'transparent',
                                  fontWeight: city === c.slug ? 600 : 400,
                                  color: city === c.slug ? '#4338CA' : '#4a5568',
                                  transition: 'background 0.2s'
                                }}
                              >
                                {c.name}
                              </div>
                            ))}
                            {filteredCities.length === 0 && (
                              <div style={{ padding: '1rem', textAlign: 'center', color: '#a0aec0' }}>
                                No cities found
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Category select */}
                    <select
                      className="form-select cat-select"
                      value={category}
                      onChange={e=>setCategory(e.target.value)}
                      data-testid="home-category-select"
                      style={{ height: '46px', borderRadius: '10px' }}
                    >
                      <option value="">Any category</option>
                      {categories.map(c => <option key={c.id} value={c.slug}>{c.name}</option>)}
                    </select>

                    {/* Search button */}
                    <button
                      className="btn-ap animated-search-btn search-submit"
                      type="submit"
                      data-testid="home-search-btn"
                      style={{
                        border: 'none',
                        padding: '0.65rem 1.8rem',
                        borderRadius: '10px',
                        fontWeight: 600,
                        cursor: 'pointer',
                        height: '46px'
                      }}
                    >
                      Search
                    </button>
                  </div>
                </div>
              </form>

              <div className="d-flex flex-wrap gap-2 mt-3">
                {['Restaurants','Salons','Gyms','Plumbing','CA'].map(t => (
                  <button
                    key={t}
                    className="btn btn-sm btn-ap-outline animated-tab-outline"
                    onClick={() => nav(`/search?q=${encodeURIComponent(t)}`)}
                    data-testid={`quick-${t.toLowerCase()}`}
                    style={{
                      padding: '0.4rem 1rem',
                      borderRadius: '20px',
                      fontWeight: 500,
                      cursor: 'pointer'
                    }}
                  >
                    {t}
                  </button>
                ))}
              </div>
            </div>
            <div className="col-lg-5">
              <div style={{ position:'relative' }}>
                <img src={HERO_IMG} alt="Modern building" style={{ width:'100%', borderRadius: 24, boxShadow:'0 30px 60px -30px rgba(15,23,42,.4)' }} />
                <div className="ap-card position-absolute" style={{ left: -16, bottom: -16, maxWidth: 220 }}>
                  <div className="text-muted-2 small mb-1">Businesses onboarded</div>
                  <div style={{ fontFamily:'Bricolage Grotesque', fontSize:'1.75rem', fontWeight:800 }}>10,000+</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== Sponsored Home Banner - Scrolling Carousel ===== */}
      {ads.length > 0 && (
        <section className="container my-5" data-testid="home-ads-strip">
          <div
            className="sponsored-banner-wrap"
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
          >
            <div
              className="sponsored-banner-track"
              style={{ transform: `translateX(-${activeSlide * 100}%)` }}
            >
              {bannerSlides.map((a, idx) => (
                <div className="sponsored-banner-slide" key={a.id || idx}>
                  <a
                    href={a.target_url || `/business/${a.business_slug || ''}`}
                    className="sponsored-banner-card"
                  >
                    <div className="sponsored-banner-img-wrap">
                      {a.image_url ? (
                        <img
                          src={a.image_url}
                          alt={a.title}
                          className="sponsored-banner-img"
                        />
                      ) : (
                        <div style={{
                          position: 'absolute', inset: 0,
                          display: 'flex', alignItems: 'center', justifyContent: 'center',
                          fontSize: '3rem', fontWeight: 800, color: '#818CF8',
                          background: 'linear-gradient(135deg, #EEF2FF, #E0E7FF)'
                        }}>
                          {(a.title || 'A').substring(0, 1).toUpperCase()}
                        </div>
                      )}
                      <div className="sponsored-banner-img-overlay" />
                    </div>
                    <div className="sponsored-banner-body">
                      <span className="sponsored-banner-eyebrow">
                        <svg width="11" height="11" viewBox="0 0 12 12" fill="none">
                          <path d="M6 1L7.5 4.5L11 4.9L8.5 7.5L9.2 11L6 9.2L2.8 11L3.5 7.5L1 4.9L4.5 4.5L6 1Z" fill="#D97706"/>
                        </svg>
                        Sponsored
                      </span>
                      <div className="sponsored-banner-title">{a.title}</div>
                      <div className="sponsored-banner-cta">
                        Learn more
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                          <path d="M3 7H11M11 7L7.5 3.5M11 7L7.5 10.5" stroke="#4338CA" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                    </div>
                  </a>
                </div>
              ))}
            </div>

            <div className="sponsored-progress" key={activeSlide} />

            {slideCount > 1 && (
              <>
                <button
                  type="button"
                  className="banner-nav-btn banner-nav-prev"
                  onClick={prevSlide}
                  aria-label="Previous slide"
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M10 3L5 8L10 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
                <button
                  type="button"
                  className="banner-nav-btn banner-nav-next"
                  onClick={nextSlide}
                  aria-label="Next slide"
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M6 3L11 8L6 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>

                <div className="banner-dots">
                  {bannerSlides.map((_, idx) => (
                    <button
                      key={idx}
                      type="button"
                      className={`banner-dot${activeSlide === idx ? ' active' : ''}`}
                      onClick={() => goToSlide(idx)}
                      aria-label={`Go to slide ${idx + 1}`}
                    />
                  ))}
                </div>
              </>
            )}
          </div>
        </section>
      )}

      {/* ===== Popular Categories - Highlighted Animated Section ===== */}
      <section className="highlight-section">
        <div className="blob blob-1" />
        <div className="blob blob-2" />
        <div className="blob blob-3" />
        <div className="deco-ring deco-ring-1" />
        <div className="deco-ring deco-ring-2" />
        <div className="shimmer-overlay" />

        <div className="position-relative" style={{ zIndex: 1 }}>
          <div className="d-flex justify-content-between align-items-end mb-4 flex-wrap gap-3">
            <div>
              <div className="section-eyebrow">Browse</div>
              <h2 className="mt-1 section-title">Popular categories</h2>
              <p className="text-muted-2 small mb-0 mt-1">Discover top-rated businesses across every category</p>
            </div>
            <Link
              to="/categories"
              className="animated-link-btn"
              data-testid="see-all-categories"
              style={{
                padding: '0.55rem 1.4rem',
                borderRadius: '10px',
                fontWeight: 600,
                textDecoration: 'none',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.4rem',
                color: '#4338CA',
                background: '#fff'
              }}
            >
              See all
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M5 3L9 7L5 11" stroke="#4338CA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </Link>
          </div>
          <div className="row g-3">
            {categories.slice(0, 8).map((c) => (
              <div className="col-6 col-md-4 col-lg-3" key={c.id}>
                <Link to={`/search?category=${c.slug}`} className="no-underline d-block h-100" data-testid={`home-category-${c.slug}`}>
                  <div className="category-card">
                    <div className="category-arrow">
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <path d="M3 9L9 3M9 3H4M9 3V8" stroke="#4338CA" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </div>
                    <div className="category-icon-wrap">{c.name.substring(0,1).toUpperCase()}</div>
                    <div className="category-name">{c.name}</div>
                    <div className="category-count">{c.business_count} businesses</div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== Featured Businesses - Highlighted Animated Section (alt variant) ===== */}
      <section className="highlight-section highlight-section-alt">
        <div className="blob blob-1" />
        <div className="blob blob-2" />
        <div className="blob blob-3" />
        <div className="deco-ring deco-ring-1" />
        <div className="deco-ring deco-ring-2" />
        <div className="shimmer-overlay" />

        <div className="position-relative" style={{ zIndex: 1 }}>
          <div className="d-flex justify-content-between align-items-end mb-4 flex-wrap gap-3">
            <div>
              <div className="section-eyebrow">Premium picks</div>
              <h2 className="mt-1 section-title">Featured businesses</h2>
              <p className="text-muted-2 small mb-0 mt-1">Hand-picked premium businesses you can trust</p>
            </div>
            <Link
              to="/search?premium=1"
              className="animated-link-btn"
              data-testid="see-all-premium"
              style={{
                padding: '0.55rem 1.4rem',
                borderRadius: '10px',
                fontWeight: 600,
                textDecoration: 'none',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.4rem',
                color: '#4338CA',
                background: '#fff'
              }}
            >
              See all
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M5 3L9 7L5 11" stroke="#4338CA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </Link>
          </div>
          <div className="row g-3">
            {featured.map(b => (
              <div className="col-md-6" key={b.id}>
                <Link to={`/business/${b.slug}`} className="no-underline d-block h-100" data-testid={`home-featured-${b.slug}`}>
                  <div className="featured-card">
                    {b.is_premium ? <div className="featured-premium-badge">Premium</div> : null}
                    <div
                      className="featured-thumb"
                      style={{ backgroundImage: (b.logo_url || b.cover_url) ? `url(${b.logo_url || b.cover_url})` : 'none' }}
                    >
                      {!(b.logo_url || b.cover_url) && (
                        <div className="featured-thumb-placeholder">{b.name.substring(0,1).toUpperCase()}</div>
                      )}
                    </div>
                    <div className="featured-body">
                      <div className="featured-name">{b.name}</div>
                      <div className="featured-meta">
                        <span>{b.category_name}</span>
                        {b.city_name && <span className="dot" />}
                        {b.city_name && <span>{b.city_name}</span>}
                      </div>
                      {b.tagline && <div className="featured-tagline">{b.tagline}</div>}
                      <div className="featured-wa">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                          <path d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z" stroke="#16a34a" strokeWidth="1.2"/>
                          <path d="M4.5 4.5L7.5 6L4.5 7.5V4.5Z" fill="#16a34a"/>
                        </svg>
                        Chat on WhatsApp
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Explore Cities Section with Dropdown */}
      <section className="container my-5">
        <div className="d-flex justify-content-between align-items-end mb-3">
          <div>
            <div className="text-muted-2 small" style={{letterSpacing:'.18em', textTransform:'uppercase', fontWeight:700}}>By location</div>
            <h2 className="mt-1">Explore cities</h2>
          </div>
        </div>

        <div
          ref={exploreDropdownRef}
          style={{
            maxWidth: 400,
            position: 'relative'
          }}
        >
          <div
            className="animated-dropdown-trigger"
            onClick={() => setShowExploreCityDropdown(!showExploreCityDropdown)}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '0.75rem 1.25rem',
              border: '2px solid #e2e8f0',
              borderRadius: '12px',
              cursor: 'pointer',
              boxShadow: '0 2px 4px rgba(0,0,0,0.02)'
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M10 10C11.3807 10 12.5 8.88071 12.5 7.5C12.5 6.11929 11.3807 5 10 5C8.61929 5 7.5 6.11929 7.5 7.5C7.5 8.88071 8.61929 10 10 10Z" stroke="#4338CA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M10 17.5C14.1667 13.3333 16.6667 9.52381 16.6667 7.5C16.6667 3.85786 13.6421 0.833333 10 0.833333C6.35786 0.833333 3.33333 3.85786 3.33333 7.5C3.33333 9.52381 5.83333 13.3333 10 17.5Z" stroke="#4338CA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span style={{
                color: '#1a202c',
                fontWeight: 500,
                fontSize: '1rem'
              }}>
                Search for a city...
              </span>
            </div>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M3 5L7 9L11 5" stroke="#a0aec0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>

          {showExploreCityDropdown && (
            <div style={{
              position: 'absolute',
              top: 'calc(100% + 8px)',
              left: 0,
              right: 0,
              background: 'white',
              border: '1px solid #e2e8f0',
              borderRadius: '12px',
              boxShadow: '0 20px 60px rgba(0,0,0,0.12)',
              zIndex: 9999,
              maxHeight: 400,
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden'
            }}>
              <div style={{ padding: '0.75rem' }}>
                <input
                  type="text"
                  placeholder="Search for a city..."
                  value={exploreCitySearchTerm}
                  onChange={(e) => setExploreCitySearchTerm(e.target.value)}
                  autoFocus
                  style={{
                    width: '100%',
                    padding: '0.75rem 1rem',
                    border: '2px solid #e2e8f0',
                    borderRadius: '8px',
                    fontSize: '0.95rem',
                    outline: 'none',
                    transition: 'border-color 0.2s'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#4338CA'}
                  onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                />
              </div>

              <div style={{
                overflowY: 'auto',
                flex: 1,
                padding: '0.25rem 0'
              }}>
                {filteredExploreCities.length > 0 ? (
                  filteredExploreCities.map(c => (
                    <div
                      key={c.id}
                      className="animated-city-item"
                      onClick={() => selectExploreCity(c.slug)}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '0.75rem 1.25rem',
                        cursor: 'pointer',
                        transition: 'all 0.15s',
                        borderLeft: '3px solid transparent'
                      }}
                    >
                      <span style={{ fontWeight: 500, color: '#1a202c' }}>{c.name}</span>
                      <span style={{
                        fontSize: '0.8rem',
                        color: '#a0aec0',
                        background: '#f7fafc',
                        padding: '0.2rem 0.6rem',
                        borderRadius: '12px'
                      }}>
                        {c.business_count || 0} businesses
                      </span>
                    </div>
                  ))
                ) : (
                  <div style={{
                    padding: '2rem 1rem',
                    textAlign: 'center',
                    color: '#a0aec0'
                  }}>
                    <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>🏙️</div>
                    <div>No cities found</div>
                    <div style={{ fontSize: '0.85rem', marginTop: '0.25rem' }}>Try a different search term</div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        <div className="mt-3">
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '0.5rem',
            alignItems: 'center'
          }}>
            <span style={{
              fontSize: '0.85rem',
              color: '#a0aec0',
              marginRight: '0.25rem'
            }}>
              Popular:
            </span>
            {cities.slice(0, 8).map(ci => (
              <button
                key={ci.id}
                className="animated-chip"
                onClick={() => nav(`/search?city=${ci.slug}`)}
                style={{
                  padding: '0.35rem 1rem',
                  border: '1px solid #e2e8f0',
                  borderRadius: '20px',
                  fontSize: '0.85rem',
                  color: '#4a5568',
                  cursor: 'pointer',
                  fontWeight: 500
                }}
                data-testid={`home-city-${ci.slug}`}
              >
                {ci.name}
              </button>
            ))}
            {cities.length > 8 && (
              <span style={{
                fontSize: '0.85rem',
                color: '#a0aec0'
              }}>
                +{cities.length - 8} more
              </span>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}